import axios from 'axios';
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
  CloseOutlined,
  CheckCircleOutlined,
  DragOutlined
} from '@ant-design/icons';

export default {
  getAgenda: async function (setFuncMap) {
    try {
      const res = await this.getAgendaAction()
      setFuncMap.setAgenda(res.data)
      setFuncMap.setIsPageLoading(false)
    } catch (error) {
    }
  },
  getAgendaAction: () => {
    return axios({
      method: 'GET',
      url: `/site/agenda`
    })
  }
};
